import BaseFormItem from "../BaseFormItem";
import Control from "lib/common/descriptorcontrols/StringField/label";
import React from "react";

export class StringFieldlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default StringFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/StringField/label.js